<template>
  <!-- 坐席选择 -->
  <div class="operator-select">
    <div class="content">
      <div class="title">{{ title }}</div>
      <el-select v-model="selectedId" clearable placeholder="请选择" style="width: 100%">
        <el-option
          v-for="item in listData"
          :key="item.serviceNo"
          :label="item.serviceNo + '--' + item.serverName + '--' + item.serverWorkStatusName"
          :value="item.serviceNo"
        >
          {{ item.serviceNo + '--' + item.serverName + '--' + item.serverWorkStatusName }}
        </el-option>
      </el-select>
      <div class="btn">
        <el-button type="primary" size="small" @click="doSave"> 确定 </el-button>
        <el-button size="small" @click="doClose">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { operatorStatusMap } from '../common';
import { getOperatorsApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'OperatorSelect',
  props: {
    title: {
      type: String,
      required: true,
    },
    operatorStatus: {
      type: Array,
      required: true,
    },
    currStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      listData: [], // 坐席列表
      selectedId: '', // 选中的坐席id
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /* 获取坐席列表 */
    getList() {
      getOperatorsApi({
        workStatus: this.operatorStatusMap[this.currStatus],
      }).then(({ data }) => {
        this.listData = data;
      });
    },
    /* 确认 */
    doSave() {
      if (!this.selectedId) {
        this.$message.warning('请先选择一个坐席!');
        return;
      }
      this.$emit('save', this.selectedId);
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.operator-select {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.3);
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    width: 250px;
    border: solid 1px #dcdfe6;
    border-radius: 5px;
    padding: 20px 10px 0;
    background: #fff;

    .title {
      margin-bottom: 10px;
    }

    .btn {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
